import { render, staticRenderFns } from "./form-setting.vue?vue&type=template&id=1990533a&scoped=true"
import script from "./form-setting.vue?vue&type=script&lang=js"
export * from "./form-setting.vue?vue&type=script&lang=js"
import style0 from "./form-setting.vue?vue&type=style&index=0&id=1990533a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990533a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1990533a')) {
      api.createRecord('1990533a', component.options)
    } else {
      api.reload('1990533a', component.options)
    }
    module.hot.accept("./form-setting.vue?vue&type=template&id=1990533a&scoped=true", function () {
      api.rerender('1990533a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/form-setting.vue"
export default component.exports